import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import Sidebar from "../Sidebar";
import styles from "./pageloader.module.css";

type PageLoaderProps = {
  label?: string;
  showSidebar?: boolean;
  activeNav?: string;
};

const PageLoader: React.FC<PageLoaderProps> = ({
  label = "Loading...",
  showSidebar = true,
  activeNav = "home",
}) => {
  return (
    <div className={styles.pageLoaderRoot}>
      {showSidebar && <Sidebar activeNav={activeNav} />}
      <div className={styles.pageLoaderMain}>
        <LoadingSpinner size="lg" label={label} fullscreen />
      </div>
    </div>
  );
};

export default PageLoader;
